jQuery(function ($) {
  var cpb = $("#product-builder");
  var redirectUrl = "/pages/my-saved-builds";

  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", init);



function getProductConfig(callback) {
_cpb.saveConfig(function(res) {
var result = [];
var product = CPB.getStore().getState().Product;
var changes = product.userChanges; 
var panels = Object.keys(changes);

panels.forEach(function(panelId) {
var title = '';
product.panels.forEach(function(panel) {
if(panel.id === panelId) {
title = panel.title;
view = panel.selectedView;
}
});
var panel = {
title: title,
categories: []
}
var categories = Object.keys(changes[panelId]);
categories.forEach(function(categoryId) {
var catLayer = changes[panelId][categoryId].layer;
var selectedOption = catLayer.option;

for(var i = 0; i < product.panels.length; i++) {
if(product.panels[i].id === panelId) {
var panelObj = product.panels[i];
break;
}
}
for(var i = 0; i < panelObj.categories.length; i++) {
if(panelObj.categories[i].id === categoryId) {
var catObj = panelObj.categories[i];
break;
}
}

var category = {
title: catObj.title,
options: []
}
catObj.options.forEach(function(option) { 
if(option.id === selectedOption) {
var title = catObj.type === 'input' ? catLayer.value : option.option.data.label;
category.options.push({
title: title,
sku: option.sku
});
}
});
panel.categories.push(category);
});
result.push(panel);
});
callback({configId: res, panels: result});
}); 
};
    console.log(getProductConfig());
});
